import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_1",
  "use": "icon-arrow_1-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-arrow_1\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M15.13,11.29l-4-3.79,1.06-1L18,12l-5.83,5.5-1.06-1,4-3.79H6V11.29Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol